export enum AB_TESTS {
  EXAMPLE = 'abtest_example',
  QUESTS = 'abtest_le_quests',
}

export const AB_TESTS_PREFIX = 'abtest';

export const AB_TESTS_START_DATE: Partial<Record<AB_TESTS, string>> = {
  [AB_TESTS.QUESTS]: '2026-02-25 00:00:00 UTC',
};

export const DATE_FORMAT = 'YYYY-MM-DD HH:mm:ss [UTC]';
